import { VesselCertificatesScreen } from '@felix/ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { useSession } from '../session.js';
import { officeVesselCertificateSource } from '../vessel-certificate-source.js';

/**
 * Compliance ▸ Vessel Certificates (plan M7 Task 27a, 27b; ADR 0029 K28–K31). Kaynak oturumdaki
 * kişiyle kurulur: basılı listenin altlığında basan kişi ve yer "Office" [NR496 4.1.2]; sayfa
 * yüklemesinin devam kaydı kişiye bağlı (inceleme M8a3-R22).
 */
export function VesselCertificatesPage() {
  const { t } = useTranslation();
  const session = useSession();
  const user = session.me?.user;
  const name = user?.fullName ?? user?.email ?? '';
  const owner = user?.id;
  const source = useMemo(
    () => officeVesselCertificateSource({ name, place: 'Office' }, owner),
    [name, owner],
  );
  return (
    <Shell title={t('menu.complianceVesselCertificates')}>
      <VesselCertificatesScreen source={source} />
    </Shell>
  );
}
